<template>
    <img class="d-block mx-auto" src="/img/stenovations.png" alt="Stenovations" width="270" height="100" />
</template>

<script>
    import { defineComponent } from 'vue'
    import { Link } from '@inertiajs/inertia-vue3';

    export default defineComponent({
        components: {
            Link,
        },
    })
</script>
